<template>
    <div class="">
        <b-row class="justify-content-center">
            <h5>{{ labels.title }}</h5>
        </b-row>
        <b-row class="justify-content-center">
            <b-col cols="1"></b-col>
            <b-col cols="3" class="text-left">
                <h5>{{labels.calificacion}}</h5>
            </b-col>
            <b-col cols="2" class="text-left">
                <h5>{{ calificacion }}</h5>
            </b-col>
            <b-col cols="6" class="text-left">
                <h5><label>Score</label></h5>
                <select v-model="zscore" @click="f_lea_informacion()">
                    <option
                        v-for="(item, idx) in listTasasScore"
                        :key="idx"
                        :value="item.tipo_tasa">
                        {{item.descripcion}}
                    </option>
                </select>
            </b-col>
        </b-row>
        <div class="row col-md-12 justify-content-center mt-3" v-if="muestraInformacion">
            <table class="tblEstandar">
                <tr style="border: 1px solid black; background-color: #2e507a; color: white;">
                    <th class="text-center">Tasa</th>
                    <th class="text-center">Valor</th>
                </tr>
                <tr style="border: 1px solid black;">
                    <td class="text-left" style="border: 1px solid black;">Tasa USA</td>
                    <td class="text-right" style="border: 1px solid black;">{{ this.TasasByVigencia.tasa_usa }}</td>
                </tr>
                <tr style="border: 1px solid black;">
                    <td class="text-left" style="border: 1px solid black;">Tasa libre de riesgo</td>
                    <td class="text-right" style="border: 1px solid black;">{{ this.TasasByVigencia.tasa_libre_riesgo }}</td>
                </tr>
                <tr style="border: 1px solid black;">
                    <td class="text-left" style="border: 1px solid black;">Tasa USD</td>
                    <td class="text-right" style="border: 1px solid black;">{{ getTasaUSD(this.TasasByVigencia.tasa_usa,this.TasasByVigencia.tasa_libre_riesgo) }}</td>
                </tr>
                <tr style="border: 1px solid black;">
                    <td class="text-left" style="border: 1px solid black;">{{ labels.riesgoPais }}</td>
                    <td class="text-right" style="border: 1px solid black;">{{ this.TasasByVigencia.embi }}</td>
                </tr>
                <tr style="border: 1px solid black;">
                    <td class="text-left" style="border: 1px solid black;">Tasa final USD</td>
                    <td class="text-right" style="border: 1px solid black;">{{ getTasaFinalUSD(this.TasasByVigencia.embi,this.TasasByVigencia.tasa_usa,this.TasasByVigencia.tasa_libre_riesgo) }}</td>
                </tr>
                <tr style="border: 1px solid black;">
                    <td class="text-left" style="border: 1px solid black;">Inflación USA</td>
                    <td class="text-right" style="border: 1px solid black;">{{ this.TasasByVigencia.inflacion_usa }}</td>
                </tr>
                <tr style="border: 1px solid black;">
                    <td class="text-left" style="border: 1px solid black;">Inflación COL</td>
                    <td class="text-right" style="border: 1px solid black;">{{ this.TasasByVigencia.inflacion_col}}</td>
                </tr>
                <!-- <tr style="border: 1px solid black;">
                    <td class="text-left" style="border: 1px solid black;">Devaluación</td>
                    <td class="text-right" style="border: 1px solid black;">{{ getDevaluacion(this.TasasByVigencia.inflacion_usa,this.TasasByVigencia.inflacion_col) }}</td>
                </tr> -->
                <!-- <tr style="border: 1px solid black;">
                    <td class="text-left" style="border: 1px solid black;">Tasa Pais origen</td>
                    <td class="text-right" style="border: 1px solid black;">{{ getTasaPaisOrigen(this.TasasByVigencia.tasa_usa,this.TasasByVigencia.tasa_libre_riesgo,this.TasasByVigencia.inflacion_usa,this.TasasByVigencia.inflacion_col) }}</td>
                </tr> -->
                <tr style="border: 1px solid black;">
                    <td class="text-left" style="border: 1px solid black;">Tasa Final</td>
                    <td class="text-right" style="border: 1px solid black;">{{ getTasaFinal(this.TasasByVigencia.embi,this.TasasByVigencia.tasa_usa,this.TasasByVigencia.tasa_libre_riesgo,this.TasasByVigencia.inflacion_usa,this.TasasByVigencia.inflacion_col) }}</td>
                </tr>
                <tr style="border: 1px solid black;">
                    <td></td>
                    <td><md-button class="md-primary" @click="f_guardarTasa">{{ labels.save }}</md-button></td>
                </tr>
            </table>
        </div>
        <div v-else>
            <h6 class="text-center">{{ labels.info }}</h6>
        </div>
    </div>
</template>

<script>
import ClasificacionTasas from '../../../services/ClasificacionTasas';
import Score from '../../../services/Score';
import TipoTasa from "../../../services/TipoTasas"
import Tasas from    '../../../services/Tasas';

export default {
    name : 'Tasas',
    props : ['infoVigencia'],
    data : () => ({
        listaTasas : [],
        TasasByVigencia : [],
        calificacion : '',
        listTasasScore : [],
    zscore : '',
    muestraInformacion: false,
    }),
    computed : {
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Tasas',
                    info : 'Ingresar las variables de calificación',
                    save : 'Guardar Tasa',
                    riesgoPais : 'Riesgo país',
                }
            }else{
                return {
                    title : 'Rates',
                    info : 'Enter rating variables',
                    save : 'Guardar Tasa',
                    riesgoPais : 'Riesgo país',
                }
            }
        }
    },
    methods:{
        getTasaUSD(tasa_usa,tasa_libre_riesgo){
            const tasaUSD = parseFloat(tasa_usa) + parseFloat(tasa_libre_riesgo)
            return tasaUSD.toFixed(6)
        },
        getTasaFinalUSD(embi,tasaUsa,tasaLibRiesgo){
            // console.log(embi,tasaUsa,tasaLibRiesgo);
            const tasa_usd = parseFloat(tasaUsa) + parseFloat(tasaLibRiesgo)
            const operacion = parseFloat(embi) + tasa_usd
            return operacion.toFixed(6)
        },
        getDevaluacion(inflacion_usa,inflacion_col){
            let devaluacion = (((1+parseFloat(inflacion_col/100))/(1+parseFloat(inflacion_usa/100)))-1)*100
            // return (((1+parseFloat(inflacion_col/100))/(1+parseFloat(inflacion_usa/100)))-1)*100
            return devaluacion.toFixed(6)
        },
        getTasaPaisOrigen(tasa_usa,tasa_libre_riesgo,inflacion_usa,inflacion_col){

            let tasaUSD = parseFloat(tasa_usa/100) + parseFloat(tasa_libre_riesgo/100)
            let devaluacion = ((1+parseFloat(inflacion_col/100))/(1+parseFloat(inflacion_usa/100)))-1
            // return (((1+tasaUSD)*(1+devaluacion))-1)*100
            let tasaPaisOrigen = (((1+tasaUSD)*(1+devaluacion))-1)*100
            return tasaPaisOrigen.toFixed(6)
        },
        getTasaFinal(embi,tasa_usa,tasa_libre_riesgo,inflacion_usa,inflacion_col){

            const tasaFinalUSD = this.getTasaFinalUSD(embi,tasa_usa,tasa_libre_riesgo)
            const calcula = tasaFinalUSD * ((1 + parseFloat(inflacion_col)/100) / (1 + parseFloat(inflacion_usa)/100))
            return calcula.toFixed(6)
        },
    f_lea_informacion () {
        this.muestraInformacion=false
        ClasificacionTasas.getAllClasificacionTasas(
                this.infoVigencia,
                this.calificacion,
                this.zscore)
        .then((res) => {
            this.listaTasas = res.data.clasificacionTasa
            this.TasasByVigencia = this.listaTasas.find((tasa) => tasa.vigencia == this.infoVigencia && tasa.calificacion == this.calificacion)
            if	(this.TasasByVigencia != undefined) {
                this.muestraInformacion=true
            }
        })
        .catch((error) => console.log(error))
    },
    f_guardarTasa() {
        const v_tasa_final =this.getTasaFinal(
            this.TasasByVigencia.embi,
            this.TasasByVigencia.tasa_usa,
            this.TasasByVigencia.tasa_libre_riesgo,
            this.TasasByVigencia.inflacion_usa,
            this.TasasByVigencia.inflacion_col)
        Tasas.grabeTasa(this.infoVigencia,this.zscore,
            v_tasa_final,this.$store.state.userId)
        .catch((error) => {
            console.log(error)
        })
    },

    },
    mounted(){
        Score.getAllScorexByVigencia(this.infoVigencia)
        .then((res) => {
            this.calificacion = res.data.qryScoreX[0].calificacion
        })
        .catch((error) => console.log(error))

        TipoTasa.leaTasasZScore()
        .then((res) => {
            this.listTasasScore = res.data.listTipoTasas
        })
        .catch((error) => console.log(error))
    this.zscore = ''
    }
}
</script>

<style>

</style>
